import { combineReducers } from 'redux';
import { toast } from 'react-toastify';

import { TOAST_DURATION } from '@/utils';
import ui from './ui';
import loading from './status/loading';
import success from './status/success';
import errors from './status/errors';
import authUser from './auth';
import serviceDirectoryEntity from './service-directory/entity';
import serviceDirectoryCategory from './service-directory/category';
import serviceDirectoryArticle from './service-directory/article';
import serviceDirectorySocial from './service-directory/social';
import serviceDirectorySummary from './service-directory/summary';
import serviceDirectoryServiceCatalogue from './service-directory/service-catalogue';
import serviceDirectoryServiceCategory from './service-directory/service-category';
import featureItems from './service-directory/feature-item';
import legalDocuments from './service-directory/legal-document';
import countryInformationRegions from './country-information/regions';
import countryInformationCountries from './country-information/countries';
import countryInformationCurrencies from './country-information/currencies';
import membershipUsers from './membership/users';
import rankItems from './service-directory/rank-items';

const appReducer = combineReducers({
  ui,
  loading,
  success,
  errors,
  authUser,
  serviceDirectoryEntity,
  serviceDirectoryCategory,
  serviceDirectoryArticle,
  serviceDirectorySocial,
  serviceDirectorySummary,
  serviceDirectoryServiceCatalogue,
  serviceDirectoryServiceCategory,
  legalDocuments,
  countryInformationRegions,
  countryInformationCountries,
  countryInformationCurrencies,
  membershipUsers,
  featureItems,
  rankItems,
});

const rootReducer = (state: any, action: any) => {
  const matchesSuccess = /(CREATE|EDIT|UPDATE|DELETE|SCRAPE)_(.*)_(SUCCESS)/.exec(action.type);
  const matchesFailed = /(CREATE|EDIT|UPDATE|DELETE|SCRAPE)_(.*)_(FAILURE)/.exec(action.type);
  const matchesCreateEntityFailed = /(CREATE_OR_UPDATE_ENTITY_FAILURE)$/.exec(action.type);

  const toastOptions = {
    autoClose: TOAST_DURATION,
  };

  // Show message when create bank with existing Name
  if (matchesCreateEntityFailed && action?.payload?.error?.response?.status === 406) {
    toast.error('Business name already exists!', toastOptions);
  } else if (matchesFailed) {
    toast.error('Something went wrong!', toastOptions);
  }
  matchesSuccess && toast.success('The action completed successfully!', toastOptions);

  return appReducer(state, action);
};

export default rootReducer;

export type RootState = ReturnType<typeof rootReducer>;
